import { TextAreaProps } from "./TextArea.types";
import { TextArea as BaseTextArea } from "@commonlibs";
import clsx from "clsx";
import TextFieldSuffix from "../TextField/TextFieldSuffix/TextFieldSuffix";
import TextFieldLabel from "../TextField/TextFieldLabel/TextFieldLabel";

const TextArea = ({
    variant = "outlined",
    size = "sm",
    className,
    label,
    showOptional,
    suffix,
    required,
    ...rest
}: TextAreaProps): JSX.Element => {
    return (
        <BaseTextArea
            suffix={<TextFieldSuffix suffix={suffix} />}
            label={typeof label === "string" ? <TextFieldLabel label={label} showOptional={showOptional} required={required} /> : label}
            required={required}
            className={clsx(className, size.capitalize(), variant.capitalize())}
            {...rest}
        />
    );
};

export default TextArea;
